import * as React from "react";
const SvgMagnifyingGlass = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: props.size || "1em",
    height: props.size || "1em",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    ...props
  },
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("path", { d: "M0 0h16v16H0z" }), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6.58 1a5.579 5.579 0 0 1 4.286 9.15l3.99 3.991.058.069a.504.504 0 0 1-.065.64.502.502 0 0 1-.71.008l-3.99-3.992A5.579 5.579 0 0 1 1 6.577 5.579 5.579 0 0 1 6.58 1Zm0 .992a4.586 4.586 0 0 0-4.587 4.585 4.586 4.586 0 0 0 4.587 4.585 4.586 4.586 0 0 0 4.588-4.585A4.586 4.586 0 0 0 6.58 1.992Z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  ))
);
const SvgMagnifyingGlass$1 = SvgMagnifyingGlass;
export {
  SvgMagnifyingGlass$1 as default
};
